import React from 'react';

/** Optional overrides from IMAGE_MAP — only templates that pass these are affected. */
export type ImageMapPopupLayoutOptions = {
  /** Extra px on fixed `left` after aligning under hotspot (Popup default without context: 100). */
  popupFixedOffsetLeftPx?: number;
  /** Extra px on fixed `top` after placing below hotspot (Popup default without context: 20). */
  popupFixedOffsetTopPx?: number;
  /** Keep anchored popups within the photo bounds horizontally (helps Interactive4 card on ultrawide). */
  clampPopupToImageMap?: boolean;
};

export const ImageMapPopupLayoutContext =
  React.createContext<ImageMapPopupLayoutOptions | null>(null);
